import { T_LANDING_PAGE_CONSTANTS } from './TYPES'

const DE_LANDING_PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS = {
  PAGE_KICKER: 'Buch. Quiz. Gemeinschaft.',
  PAGE_TITLE: 'Eine Quizbibliothek, in der Lesen und Spielen zusammenkommen.',
  PAGE_DESCRIPTION:
    'Kinder lesen Bücher offline und beantworten anschließend kurze Quizze, die ihr Textverständnis überprüfen. Dabei sammeln sie Punkte, entwickeln ihren Greifvogel Griffy weiter und können an Lese-Challenges teilnehmen.',
  GET_STARTED_CTA_TEXT: 'Konto kostenlos erstellen',
  CARD_1_TITLE: 'Lies ein Buch',
  CARD_1_DESCRIPTION: 'Lies ein Buch – ohne Bildschirm.',
  CARD_2_TITLE: 'Beantworte das Quiz',
  CARD_2_DESCRIPTION:
    'Verbessere dein Leseverständnis und werde Teil einer Lesegemeinschaft.',
  CARD_3_TITLE: 'Sammle Belohnungen',
  CARD_3_DESCRIPTION: 'Verdiene Punkte und Abzeichen und lass Griffy wachsen.',
  FEATURES_KICKER: 'WAS IST GRIFFYREADS? ERZÄHL MIR MEHR',
  FEATURES_TITLE: 'Über seine Funktionen',
  FEATURES_CHILD_LABEL: 'FÜR KINDER',
  FEATURES_ADULT_LABEL: 'FÜR ERWACHSENE',
  FEATURES_ENHANCE_READING_TITLE: [
    { label: 'Beginne Dein' },
    {
      label: 'Abenteuer',
      color: true
    },
    { label: 'mit dem Lesen', newLine: true }
  ],
  FEATURES_ENHANCE_READING_DESCRIPTION:
    'Lies Bücher offline und stelle dich spannenden Herausforderungen in verschiedenen Genres! Tägliches Lesen fördert deinen Wortschatz und deine Kommunikationsfähigkeiten, steigert deine Kreativität und verstärkt deine Empathie, während es das Lernen unterhaltsam und lohnend macht.',
  FEATURES_UNLOCK_AVATARS_TITLE: [
    { label: 'Beantworte Quizfragen, sammle Punkte' },
    {
      label: '& fördere dein Griffy',
      color: true
    }
  ],
  FEATURES_UNLOCK_AVATARS_DESCRIPTION:
    'Teste dein Wissen mit lustigen Quizfragen und sammle Punkte für jede richtige Antwort! Steige im Level auf und sieh zu, wie dein Griffy stärker wird, während Du dich auf neue Abenteuer begibst.',
  FEATURES_CHALLENGE_FRIENDS_TITLE: [
    {
      label: 'Fordere',
      color: true
    },
    {
      label: 'Freunde heraus'
    }
  ],
  FEATURES_CHALLENGE_FRIENDS_DESCRIPTION:
    'Stelle dich Leseherausforderungen und sieh, wer die meisten Punkte sammeln kann. Möge der beste Leser gewinnen!',
  FEATURES_EARN_BADGES_TITLE: [
    { label: 'Verdiene' },
    {
      label: 'Abzeichen',
      color: true
    }
  ],
  FEATURES_EARN_BADGES_DESCRIPTION:
    'Verdiene verschiedene Abzeichen für deine Leistungen und Fortschritte!',
  FEATURES_CREATE_COMPETITIONS_TITLE: [
    { label: 'Erstellen Sie' },
    {
      label: 'spannende',
      color: true,
      newLine: true
    },
    { label: 'Lesewettbewerbe' }
  ],
  FEATURES_CREATE_COMPETITIONS_DESCRIPTION:
    'Fördere das Lesen, indem Du spannende Wettbewerbe für deine Kinder oder die Gemeinschaft erstellst. Motiviere junge Leser, an unterhaltsamen, lehrreichen Herausforderungen teilzunehmen!',
  FEATURES_MANAGE_AND_TRACK_TITLE: [
    { label: 'Verwalte' },
    {
      label: 'und',
      color: true
    },
    { label: 'verfolge' },
    {
      label: 'mühelos',
      color: true
    },
    {
      label: 'das Lesen der Kinder'
    }
  ],
  FEATURES_MANAGE_AND_TRACK_DESCRIPTION:
    'Das Verfolgen des Lesens der Kinder und das Organisieren von Wettbewerben ist ein Kinderspiel. Überwache mühelos den Fortschritt, die Leistungen und Herausforderungen jedes Kindes!',
  FEATURES_CONTRIBUTE_TITLE: [
    { label: 'Trage Quizfragen bei und' },
    {
      label: 'Wachse',
      color: true,
      newLine: true
    },
    { label: 'die Plattform' }
  ],
  FEATURES_CONTRIBUTE_DESCRIPTION:
    'Lade deine eigenen Quizfragen hoch, um unsere Bibliothek mit Bildungsinhalten zu erweitern. Deine Beiträge verbessern direkt das Lernerlebnis für junge Leser!',

  HIGHLIGHT_TITLE: 'Sicher und für Kinder gemacht',
  HIGHLIGHT_DESCRIPTION:
    'Ein kinderfreundlicher Raum, in dem Lernen auf Spaß trifft. Eltern können sich entspannen, da sie wissen, dass ihre Kinder in einer sicheren Umgebung sind.',
  DOWNLOAD_TITLE: 'Worauf wartest Du?',
  DOWNLOAD_DESCRIPTION:
    'Die magische Welt von GriffyReads ist nur einen Klick entfernt. Melde dich jetzt an und beginne deine aufregende Lese-Reise. Fördere dein Griffy, sammle Punkte und werde ein Lese-Champion!'
}

export default DE_LANDING_PAGE_CONSTANTS
